export var semanticPalette = {
    "input": {
        "border": {
            "default": "#c7caf1",
            "hovered": "#686c94",
            "error": "#cc2e50",
            "readonly": "#cdc9ce",
            "active": "#e8eaf9",
            "disabled": "#f5f5fa",
            "success": {
                "strong": "#027e46",
                "weak": "#ebf5ee"
            },
            "checked": "#5a61b2"
        },
        "surface": {
            "default": "#fcfcff",
            "hovered": "#fafafe",
            "active": "#ffffff",
            "readonly": "#fbfafb",
            "disabled": "#fafafe",
            "success": {
                "weak": "#ebf5ee",
                "strong": "#027e46"
            },
            "checked": {
                "default": "#5a61b2",
                "readonly": "#161517"
            }
        }
    },
    "text": {
        "placeholder": "#79757b",
        "default": "#161517",
        "readonly": "#464247",
        "success": {
            "strong": "#027e46",
            "weak": "#ebf5ee"
        },
        "error": "#cc2e50",
        "onDark": "#ffffff",
        "disabled": "#c3bfc5",
        "hovered": "#2c305d",
        "warning": "#a27911",
        "info": "#2f7abc",
        "heading": "#161517",
        "label": "#161517"
    },
    "icon": {
        "default": "#79757b",
        "active": "#161517",
        "disabled": "#ada8ae",
        "error": {
            "strong": "#cc2e50"
        },
        "success": {
            "strong": "#027e46"
        },
        "onDark": "#ffffff",
        "warning": {
            "strong": "#a27911"
        },
        "info": {
            "strong": "#2f7abc"
        }
    },
    "dropdown": {
        "surface": {
            "default": "#ffffff",
            "hovered": "#f9f9ff",
            "active": "#ebf5ee"
        },
        "border": {
            "default": "#e8eaf9"
        }
    },
    "utility": {
        "divider": "#e8e5ea",
        "brand": "#4de2f5",
        "success": {
            "strong": "#027e46",
            "weak": "#ebf5ee"
        },
        "error": {
            "strong": "#cc2e50",
            "weak": "#faeff1"
        },
        "warning": {
            "strong": "#a27911",
            "weak": "#faf4e5"
        },
        "info": {
            "strong": "#2f7abc",
            "weak": "#f7fbfd"
        },
        "neutral": {
            "strong": "#908c92",
            "weak": "#f4f1f5"
        },
        "surface": "#ffffff",
        "overlay": "#11142b",
        "focus": "#2f7abc",
        "link": "#79757B"
    },
    "tooltip": {
        "surface": "#353a71"
    },
    "dialog": {
        "surface": "#ffffff",
        "border": "#e8eaf9"
    },
    "buttons": {
        "primary": {
            "surface": {
                "default": "#313347",
                "hovered": "#5b5f83",
                "disabled": "#f0f0fa",
                "loading": "#fcfcff"
            },
            "contents": {
                "default": "#ffffff",
                "disabled": "#cdc9ce",
                "loading": "#161517"
            }
        },
        "secondary": {
            "surface": {
                "default": "#fafafe",
                "hovered": "#ffffff",
                "disabled": "#ffffff",
                "loading": "#ffffff"
            },
            "contents": {
                "default": "#353a71",
                "disabled": "#cdc9ce",
                "loading": "#161517"
            },
            "border": {
                "default": "#e8eaf9",
                "hovered": "#fafafe",
                "disabled": "#cdc9ce",
                "loading": "#e8eaf9"
            }
        },
        "tertiary": {
            "border": {
                "hovered": "#f5f5fa"
            },
            "surface": {
                "hovered": "#ffffff"
            },
            "contents": {
                "default": "#5a61b2",
                "disabled": "#cdc9ce",
                "loading": "#161517",
                "hovered": "#0b0c17"
            }
        },
        "tertiaryNeutral": {
            "border": {
                "hovered": "#f5f5fa"
            },
            "surface": {
                "hovered": "#ffffff"
            },
            "contents": {
                "default": "#6e6a70",
                "disabled": "#cdc9ce",
                "loading": "#161517",
                "hovered": "#161517"
            }
        },
        "tertiaryOnDark": {
            "border": {
                "hovered": "#f5f5fa"
            },
            "surface": {
                "hovered": "#ffffff"
            },
            "contents": {
                "default": "#ffffff",
                "disabled": "#cdc9ce",
                "loading": "#ffffff",
                "hovered": "#161517"
            }
        },
        "critical": {
            "primary": {
                "surface": {
                    "default": "#cc2e50",
                    "hovered": "#b72948"
                },
                "contents": {
                    "default": "#ffffff",
                    "disabled": "#faeff1"
                }
            },
            "secondary": {
                "surface": {
                    "default": "#ffffff",
                    "hovered": "#faeff1"
                },
                "contents": {
                    "default": "#cc2e50",
                    "disabled": "#faeff1"
                },
                "border": {
                    "default": "#cc2e50",
                    "disabled": "#faeff1"
                }
            },
            "tertiary": {
                "contents": {
                    "default": "#cc2e50",
                    "disabled": "#faeff1",
                    "hovered": "#b72948"
                }
            }
        }
    },
    "stepItem": {
        "indicator": {
            "active": "#5a61b2",
            "disabled": "#cdc9ce",
            "complete": "#cdc9ce",
            "hovered": "#9f9ba1"
        },
        "text": {
            "default": "#6e6a70",
            "hovered": "#161517",
            "disabled": "#cdc9ce",
            "active": "#5a61b2"
        }
    },
    "card": {
        "surface": {
            "default": "#fcfcff",
            "hovered": "#ffffff"
        },
        "border": {
            "default": "#fcfcff",
            "hovered": "#e8eaf9"
        }
    },
    "navItem": {
        "default": "#212330",
        "hovered": "#313347",
        "selected": "#40425d",
        "contents": "#ffffff",
        "notification": "#4de2f5"
    },
    "navPopover": {
        "surface": "#212330",
        "border": "#40425d"
    },
    "dataViz": {
        "stem": "#ffffff",
        "pinBorder": "#ffffff",
        "axisLines": "#f4f1f5",
        "pinFill": "#4de2f5"
    },
    "listItems": {
        "surface": {
            "default": "#fcfcff",
            "hovered": "#ffffff"
        },
        "border": {
            "default": "#fcfcff",
            "hovered": "#e8eaf9"
        }
    },
    "layout": {
        "containerSurface": "#f5f5fa",
        "pageSurface": "#212330"
    },
    "popover": {
        "surface": {
            "default": "#ffffff",
            "hovered": "#f9f9ff",
            "active": "#ebf5ee"
        },
        "border": {
            "default": "#e8eaf9"
        }
    },
    "sheet": {
        "surface": "#ffffff",
        "border": "#e8eaf9"
    },
    "modal": {
        "surface": "#ffffff",
        "border": "#e8eaf9"
    },
    "status": {
        "success": {
            "strong": "#027e46",
            "weak": "#ebf5ee"
        },
        "error": {
            "strong": "#cc2e50",
            "weak": "#faeff1"
        },
        "warning": {
            "strong": "#a27911",
            "weak": "#faf4e5"
        },
        "info": {
            "strong": "#2f7abc",
            "weak": "#f7fbfd"
        }
    },
    "table": {
        "border": {
            "default": "#e8e5ea",
            "hovered": "#686c94",
            "weak": "#f5f5fa",
            "strong": "#c7caf1",
            "selected": "#027e46"
        },
        "background": {
            "default": "#ffffff",
            "header": "#f4f4f5",
            "selected": "#ebf5ee",
            "hovered": "#f9f9ff",
        }
    }
};
//# sourceMappingURL=semantic-palette.js.map